import { render, staticRenderFns } from "./cebsbInfo_community_courseDetail.vue?vue&type=template&id=6787fff3&scoped=true&"
import script from "./cebsbInfo_community_courseDetail.vue?vue&type=script&lang=js&"
export * from "./cebsbInfo_community_courseDetail.vue?vue&type=script&lang=js&"
import style0 from "./cebsbInfo_community_courseDetail.vue?vue&type=style&index=0&id=6787fff3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6787fff3",
  null
  
)

export default component.exports